import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const CustomBar = ({ x, y, width, height, payload }) => {
  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={10}
        ry={10}
        fill={payload.fill}
      />
    </g>
  );
};

const HairCoverStatusChart = ({ stats }) => {
  if (!stats) return null;

  const data = [
    {
      name: "Hair Covered",
      count: stats.hair_covered_true,
      fill: "#00a86b",
    },
    {
      name: "Not Covered",
      count: stats.hair_covered_false,
      fill: "#ff3c3c",
    },
  ];

  return (
    <div
      style={{
        height: "400px",
        background: "#FFF",
        padding: "50px 30px",
        borderRadius: "15px",
        border: "1px solid #CDCDCD",
        boxShadow: "2px 4px 5px #DDD",
      }}
    >
      <h5 style={{ marginBottom: "20px" }}>Hair Covering Status</h5>
      <hr />
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis
            type="category"
            dataKey="name"
            label={{
              value: "Status",
              position: "insideBottom",
              dy: 10,
            }}
          />
          <YAxis
            type="number"
            label={{
              value: "Count",
              angle: -90,
              position: "insideLeft",
            }}
          />
          <Tooltip />
          <Bar
            dataKey="count"
            shape={<CustomBar />}
            background={{ fill: "#eee" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HairCoverStatusChart;
